export var defaultProps = {
  font: 'primary',
  fontSize: 'T300',
  hyphens: 'none'
};
export var textPropsToFilter = ['color', 'display', 'font', 'fontSize', 'fontWeight', 'hyphens', 'isInMobileLayout', 'lineHeight', 'margin', 'shouldUseFixedFontStyle', 'textAlign', 'textDecoration', 'wordBreak'];